import { FC, SVGProps } from "react";

const CheckSuccessIcon: FC<SVGProps<SVGSVGElement>> = ({fill = "#50CD89", ...props}) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
      <path
        d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
        fill="currentcolor"
      />
      <path
        d="M22 32C21.488 32 20.976 31.804 20.586 31.414L14.586 25.414C13.804 24.632 13.804 23.368 14.586 22.586C15.368 21.804 16.632 21.804 17.414 22.586L22 27.172L30.586 18.586C31.368 17.804 32.632 17.804 33.414 18.586C34.196 19.368 34.196 20.632 33.414 21.414L23.414 31.414C23.024 31.804 22.512 32 22 32Z"
        fill="white"
      />
    </svg>
  );
};

export default CheckSuccessIcon;